import { IOfferCard } from '../../../../types/card';
import { sortGeo } from '../../utils';

export const prepareRailway = ({ geo }: IOfferCard) => {
  const sortedGeoIds = geo?.sortedGeoIds || [];
  const railways = geo?.railways || [];

  const sortedRailways = sortGeo({ sortedGeoIds, geoItems: railways, sortedType: 'railway' });

  return sortedRailways[0];
};
